import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../../stores';

interface SysadminRouteProps {
  children: React.ReactNode;
}

export const SysadminRoute: React.FC<SysadminRouteProps> = ({ children }) => {
  const location = useLocation();
  const { user } = useAuthStore();

  if (!user?.isSuperAdmin) {
    return <Navigate to="/unauthorized" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};

export default SysadminRoute;
